import RootOutlet from '@app-studio-web/ui/components/RootOutlet'
import createAccountRoutes from '@app-studio-web/ui/pages/account/accountRoutes'
import checkoutRoutes from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import ErrorPage from '@app-studio-web/ui/pages/ErrorPage'
import helpCenterRoutes from '@app-studio-web/ui/pages/helpCenter/helpCenterRoutes'
import LandingPage from '@app-studio-web/ui/pages/LandingPage'
import signUpRoutes from '@app-studio-web/ui/pages/signUp/signUpRoutes'
import { Navigate, Outlet } from 'react-router-dom'
import onboardingRoutes from './onboarding/onboardingRoutes'

const routes = [
  {
    element: <RootOutlet />,
    errorElement: <ErrorPage />,
    path: '/',
    children: [
      {
        element: <LandingPage />,
        index: true,
      },
      {
        element: <Outlet />,
        path: 'account',
        children: createAccountRoutes(),
      },
      {
        element: <Outlet />,
        path: 'checkout',
        children: checkoutRoutes,
      },
      {
        element: <Outlet />,
        path: 'help-center',
        children: helpCenterRoutes,
      },
      {
        element: <Outlet />,
        path: 'onboarding',
        children: onboardingRoutes,
      },
      {
        element: <Outlet />,
        path: 'sign-up',
        children: signUpRoutes,
      },
      {
        element: <Navigate to="/onboarding" replace />,
        path: '*',
      },
    ],
  },
]

export default routes
